export function convertMapBboxToAPIBbox(bounds) {
  if (!bounds) {
    return {
      minLat: -90,
      maxLat: 90,
      minLong: -180,
      maxLong: 180
    }
  }
  const { ne, nw, se, sw } = bounds
  if (!ne || !nw || !se || !sw) {
    return {
      minLat: -90,
      maxLat: 90,
      minLong: -180,
      maxLong: 180
    }
  }
  let minLat = 999
  let maxLat = -999
  let minLong = 999
  let maxLong = -999

  //menor latitude
  if (ne.lat < minLat) {
    minLat = ne.lat
  }
  if (nw.lat < minLat) {
    minLat = nw.lat
  }
  if (se.lat < minLat) {
    minLat = se.lat
  }
  if (sw.lat < minLat) {
    minLat = sw.lat
  }
  //maior latitude
  if (ne.lat > maxLat) {
    maxLat = ne.lat
  }
  if (nw.lat > maxLat) {
    maxLat = nw.lat
  }
  if (se.lat > maxLat) {
    maxLat = se.lat
  }
  if (sw.lat > maxLat) {
    maxLat = sw.lat
  }

  //menor longitude
  if (ne.lng < minLong) {
    minLong = ne.lng
  }
  if (nw.lng < minLong) {
    minLong = nw.lng
  }
  if (se.lng < minLong) {
    minLong = se.lng
  }
  if (sw.lng < minLong) {
    minLong = sw.lng
  }
  //maior longitude
  if (ne.lng > maxLong) {
    maxLong = ne.lng
  }
  if (nw.lng > maxLong) {
    maxLong = nw.lng
  }
  if (se.lng > maxLong) {
    maxLong = se.lng
  }
  if (sw.lng > maxLong) {
    maxLong = sw.lng
  }
  return {
    minLat,
    maxLat,
    minLong,
    maxLong
  }
}
